<template>
    <div>
        <div class="dropdown" v-if="$hasPermission('deals.create')">
            <button class="btn btn-primary" type="button" :id="'dropdownMenuButton' + _uid" @click="showCreate">
                Создать сделку
            </button>
        </div>
        <el-dialog width="900px" :visible.sync="form_state" :title="'Создание сделки'" :append-to-body="true">
            <DealForm v-if="$hasPermission('deals.create') && form_state" :mode="'create'" :deal="form_obj"  @created="onCreated"/>
        </el-dialog>
        <DealList v-if="$hasPermission('deals.show')" class="mt-2" source="request" :source_id="+request_id"/>
    </div>
</template>

<script>
import DealForm from "../deals/DealForm";
import DealList from "../deals/DealList";
export default {
    name: "RequestDealsBlock",
    components: {DealList, DealForm},
    props: {
        request_id: {required: true},
        platform_id: {required: true},
    },
    data: () => ({
        form_state: false,
        form_obj: false,
    }),
    mounted() {

    },
    methods: {
        showCreate() {
            this.form_state = true;
            this.form_obj = {
                request_id: this.request_id,
                platform_id: this.platform_id,
                status: 0,
                document_date: moment().format('YYYY-MM-DD'),
                in_credit: true
            };
        },
        onCreated(deal) {
            this.form_state = false;
        },
    }
}
</script>

<style scoped>

</style>
